<template>
    <div class="product-image-container-fluid mb-md-20px mb-0px carousel_thumb">
        <div class="carousel-slide__product-image">
            <NuxtLink :to="`/${item_blog.slug}`" class="thumbnail-product-carousel">
                <div class="product-tags"></div> 
                <img class="img-fluid mb-30px d-md-none" :src="item_blog.image_full_mb" :alt="item_blog?.image_alt"> 
                <img class="img-fluid mb-30px d-none d-md-block" :src="item_blog.image_full_pc" :alt="item_blog?.image_alt"> 
            </NuxtLink>
        </div>
        <p class="agp-light fs-14 mb-10px">
            <NuxtLink :to="`/${item_blog.slug}`" v-html = "htmlSpecialcharsDecode(item_blog.title)"></NuxtLink>
        </p> 
    </div>
</template>

<script setup lang="ts">
    import { computed } from 'vue';
    const props = defineProps(["item"]);
    const item_blog = computed(() => props.item || []);
</script>

